<template>
  <div class="margin-bottom-xs text-center">
    <img id="barcode-image" class="margin-bottom-xs" alt="Barcode" :src="fetchBarCodeImage" />
    <div v-if="!hideNumber" id="barcode-number" class="medium" v-text="formattedBarcodeNumber"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { padStart } from '@/utils/General';

const props = defineProps({
  barcodeNumber: {
    type: String,
    required: true,
  },
  hideNumber: {
    type: Boolean,
    default: false,
  },
  doPad: {
    type: Boolean,
    default: false,
  },
});

const fetchBarCodeImage = computed(
  () =>
    `/api/ordermodsreturns/v1/returns/barcodegenerator?no=${
      props.doPad ? padStart(props.barcodeNumber) : props.barcodeNumber
    }&format=PRINT128&add_hex=false`,
);
const formattedBarcodeNumber = computed(() => (props.doPad ? padStart(props.barcodeNumber) : props.barcodeNumber));
</script>

<style lang="scss" scoped>
#barcode-image {
  width: rem-calc(180);
  height: rem-calc(60);
}
</style>
